import React from 'react';
import { useNavigate } from 'react-router-dom';
import { playClick } from '../utils/SoundManager';

/**
 * Modal جذاب يظهر عند محاولة الإرسال الثاني (للأعضاء المجانيين)
 * يدعوهم لترقية الحساب
 */
function UpgradeModal({ open, onClose, title, message }) {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <div
      data-testid="upgrade-modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.55)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        animation: 'fadeIn 0.25s ease-out',
      }}
    >
      <div
        data-testid="upgrade-modal"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--card-bg)',
          borderRadius: '24px',
          padding: '32px 26px',
          maxWidth: '420px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 24px 60px rgba(0, 0, 0, 0.35)',
          border: '1px solid var(--border-color)',
          animation: 'slideUp 0.3s ease-out',
          position: 'relative',
        }}
      >
        {/* Close X */}
        <button
          data-testid="upgrade-modal-close"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '14px',
            left: '14px',
            background: 'transparent',
            border: 'none',
            fontSize: '22px',
            color: 'var(--text-light)',
            cursor: 'pointer',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          ✕
        </button>

        {/* Lock Icon with shine */}
        <div
          style={{
            width: '90px',
            height: '90px',
            margin: '0 auto 18px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #FFD700, #FFA500)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '44px',
            boxShadow: '0 10px 30px rgba(255, 165, 0, 0.4)',
            position: 'relative',
          }}
          className="heartbeat"
        >
          🔒
        </div>

        <h2
          style={{
            fontSize: '22px',
            color: 'var(--text-dark)',
            marginBottom: '10px',
            fontFamily: "'Tajawal', sans-serif",
            fontWeight: '800',
          }}
        >
          {title || 'ميزة Premium حصرية'}
        </h2>

        <p
          style={{
            fontSize: '15px',
            color: 'var(--text-light)',
            lineHeight: '1.9',
            marginBottom: '24px',
          }}
        >
          {message || 'استمتع برسائل غير محدودة، توصيات ذكية، ومميزات حصرية مع الباقة المميزة'}
        </p>

        {/* Benefits list */}
        <div
          style={{
            background: 'rgba(255, 215, 0, 0.08)',
            border: '1px solid rgba(255, 215, 0, 0.25)',
            borderRadius: '14px',
            padding: '14px 16px',
            marginBottom: '20px',
            textAlign: 'right',
          }}
        >
          {[
            '💬 رسائل غير محدودة لكل محادثة',
            '👀 رؤية من شاهد ملفك',
            '🎯 توصيات توافق متقدمة',
            '⭐ شارة عضو موثّق',
          ].map((b, i) => (
            <div
              key={i}
              style={{
                fontSize: '13px',
                color: 'var(--text-dark)',
                padding: '5px 0',
                fontWeight: '500',
              }}
            >
              {b}
            </div>
          ))}
        </div>

        <button
          data-testid="upgrade-modal-cta"
          onClick={() => {
            playClick();
            navigate('/pricing');
            onClose();
          }}
          className="btn btn-primary btn-glow"
          style={{
            width: '100%',
            padding: '15px',
            fontSize: '16px',
            fontWeight: '700',
            marginBottom: '10px',
          }}
        >
          ✨ اشترك الآن — يبدأ من 19 ر.س
        </button>

        <button
          data-testid="upgrade-modal-later"
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'var(--text-light)',
            fontSize: '13px',
            cursor: 'pointer',
            padding: '8px',
          }}
        >
          ربما لاحقاً
        </button>

        {/* Hint about referral */}
        <div
          style={{
            marginTop: '16px',
            paddingTop: '16px',
            borderTop: '1px dashed var(--border-color)',
            fontSize: '12px',
            color: 'var(--text-light)',
          }}
        >
          💡 أو احصل على Premium مجاناً عبر{' '}
          <span
            data-testid="upgrade-modal-referral-link"
            onClick={() => {
              playClick();
              navigate('/referral');
              onClose();
            }}
            style={{
              color: 'var(--primary)',
              cursor: 'pointer',
              fontWeight: '700',
              textDecoration: 'underline',
            }}
          >
            دعوة الأصدقاء
          </span>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default UpgradeModal;
